import { useContext, useState } from "react"
import { useIntl } from "react-intl"
import { useNavigate } from "react-router-dom";
import RouterLink from "../../link/RouterLink";

import { NavbarContext } from "../navbarContext"
import { SearchSVG } from "../../../svg"

import useStoryblokSearchResultsPage from "../../../hooks/useStoryblokSearchResults"
import { buildInternalPath } from "../../../helpers/URLHelpers";


import styles from "./searchBar.module.scss"

function SearchBar() {
  const [searchLink, setSearchLink] = useState(''),
        intl = useIntl(),
        navContext = useContext(NavbarContext)
  const {data: searchResultsStory} = useStoryblokSearchResultsPage();
  const navigate = useNavigate();

  function handleKeyPress(e) {
    if(e.which === 13) {
      navigate(searchLink);
    }
  }

  const handleChange = ({ target: { value } }) => {
    setSearchLink(buildInternalPath(`${searchResultsStory?.slug}?s=${encodeURIComponent(value)}`))
  };

  return (
    <div className={`${styles.searchBar} ${navContext.search_is_visible ? styles.searchBarVisible : ""}`}>
      <div className={styles.content}>
        <input 
          type="text" 
          onChange={handleChange}
          onKeyDown={handleKeyPress}
          placeholder={intl.formatMessage({id: "component.navbar.search.placeholder"})}
        />
        <RouterLink to={searchLink}>
          <SearchSVG />
        </RouterLink>
      </div>
    </div>
  )
}

export default SearchBar
